import { render } from "./PostsCounter.vue?vue&type=template&id=f3691426&scoped=true&ts=true"
import script from "./PostsCounter.vue?vue&type=script&lang=ts"
export * from "./PostsCounter.vue?vue&type=script&lang=ts"

import "./PostsCounter.vue?vue&type=style&index=0&id=f3691426&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3691426"]])

export default __exports__